
var magnific_translations = {
	tClose: {
		lt: 'Close (Esc)',
		en: 'Close (Esc)',
	} , // Alt text on close button
	tLoading: {
		lt: 'Kraunasi...',
		en: 'Loading...'
	}, // Text that is displayed during loading. Can contain %curr% and %total% keys
	gallery: {
		tPrev: {
			lt: 'Ankstesnysis',
			en: 'Previous (Left arrow key)' // Alt text on left arrow
		},
		tNext: {
			lt: 'Sekantis',
			en: 'Next (Right arrow key)'
		}, // Alt text on right arrow
		tCounter: {
			lt: '%curr% iš %total%',
			en: '%curr% of %total%'// Markup for "1 of 7" counter
		} 
	},
	image: {
		tError: {
			lt: 'Nepavyko pakrauti <a href="%url%">nuotraukos</a>.',
			en: '<a href="%url%">The image</a> could not be loaded.'// Error message when image could not be loaded
		} 
	},
	ajax: {
		tError: {
			lt: 'Nepavyko užkrauti <a href="%url%">turinio</a>.',
			en: '<a href="%url%">The content</a> could not be loaded.' // Error message when ajax request failed
		}
	}
}

$.extend(true, $.magnificPopup.defaults, {
	tClose: magnific_translations.tClose[locale], // Alt text on close button
	tLoading: magnific_translations.tLoading[locale], // Text that is displayed during loading. Can contain %curr% and %total% keys
	gallery: {
	  tPrev: magnific_translations.gallery.tPrev[locale], // Alt text on left arrow
	  tNext:  magnific_translations.gallery.tNext[locale], // Alt text on right arrow
	  tCounter:  magnific_translations.gallery.tCounter[locale] // Markup for "1 of 7" counter
	},
	image: {
	  tError: magnific_translations.image.tError[locale] // Error message when image could not be loaded
	},
	ajax: {
	  tError: magnific_translations.ajax.tError[locale] // Error message when ajax request failed
	}
});
  